module.exports = __webpack_public_path__ + "static/placeholder-22d5d7379cf0a69bf833d1be307278c3.png";